import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { ApiNameToProductTranslationKeyMap } from '../../constants/ApiNameToProductTranslationKeyMap';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector, hasProductsSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import CompareCTA from './CompareCTA';
import ComparePriceDisplay from './ComparePriceDisplay';
import { TableStyles } from './CompareStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Table = styled.table.withConfig({
  displayName: "ComparePageStatusFooter__Table",
  componentId: "sc-11dxz37-0"
})(["", ""], TableStyles);
const ComparePageStatusFooter = ({
  highlightedProducts
}) => {
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const hasProductsSucceeded = useAppSelector(hasProductsSucceededSelector);
  return /*#__PURE__*/_jsxs(Table, {
    columns: highlightedProducts.length + 1,
    children: [/*#__PURE__*/_jsx("thead", {
      className: "collapsed",
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          "aria-hidden": "true"
        }), highlightedProducts.map(apiName => {
          return /*#__PURE__*/_jsx("th", {
            scope: "col",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: ApiNameToProductTranslationKeyMap[apiName]
            })
          }, apiName);
        })]
      })
    }), /*#__PURE__*/_jsx("tfoot", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          "aria-hidden": "true"
        }), highlightedProducts.map(apiName => /*#__PURE__*/_jsxs("td", {
          className: "text-center",
          children: [/*#__PURE__*/_jsx("div", {
            className: "m-top-6",
            children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
              isLoading: !hasPricingAndPurchasingSucceeded || !hasProductsSucceeded,
              heights: [25],
              widths: [110],
              className: "flex-column align-center",
              Content: ComparePriceDisplay,
              contentProps: {
                apiName
              }
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "m-top-3 m-bottom-12",
            children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
              isLoading: !hasPricingAndPurchasingSucceeded || !hasProductsSucceeded,
              heights: [40],
              widths: [110],
              className: "flex-column align-center",
              Content: CompareCTA,
              contentProps: {
                apiName
              }
            })
          })]
        }, apiName))]
      })
    })]
  });
};
export default ComparePageStatusFooter;